import ProfessionalCategory from './ProfessionalCategory'

class SpainProfessionalCategory extends ProfessionalCategory {
  static urlRoot() {
    return '/contracts/spain/professional_categories'
  }
}

export default SpainProfessionalCategory
